import React, { useEffect, useMemo, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon } from '../../../../../components/Component';
import  ReactDataTable   from './ReactDataTable/ReactDataTable';
import Content from '../../../../../layout/content/Content';
import Head from '../../../../../layout/head/Head';
import { getAllScratchCardWinners } from '../../../../../redux/admin/promotion/action';
import { Link } from 'react-router-dom';
import { Table } from 'antd';

const ScratchCardWinner = () => {
    const dispatch = useDispatch(); //defining dispatch

    //function to get data from backend
    useEffect(() => {
        dispatch(getAllScratchCardWinners());
    }, []);

    //to store data from application state to a constant
    const getSelectors = (state) => ({
        scratch_card_winners: state.promotion.scratch_card_winners,
    });
    const { scratch_card_winners } = useSelector(getSelectors);

    const [scrachWinnerTableDatas, setScrachWinnerTableDatas] = useState([]);  //data state defined

    useEffect(() => {
        if (scratch_card_winners && scratch_card_winners.length > 0) {
            const datas = [];
            if (scratch_card_winners.length) {
                scratch_card_winners?.map((item) => {
                    datas.push({
                        id: item.id,
                        name: item.user?.name,
                        scratch_card: item?.scratch_card?.name,
                        order_id: item?.order?.unique_order_id,
                        collection_status: item.is_collected ? "COLLECTED" : "PENDING",
                        amount: item?.amount,
                        date: moment.utc(item.created_at).local().fromNow(),
                    });
                    return item;
                });
                if (datas.length) setScrachWinnerTableDatas(datas);
            } else {
                setScrachWinnerTableDatas([]);
            }
        }
    }, [scratch_card_winners]);


    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.user?.name,
            sortable: true,
        },
        {
            name: "Scratch Card",
            selector: (row) => row.scratch_card?.name,
            sortable: true,
        },

        {
            name: "Order ID",
            selector: (row) => row.order?.unique_order_id,
            sortable: true,
        },

        {
            name: "Collection Status",
            selector: (row) => row.is_collected ? "COLLECTED" : "PENDING",
            sortable: true,
        },
        {
            name: "Amount",
            selector: (row) => row.amount,
            sortable: true,
        },
        {
            name: "Date",
            selector: (row) => row.created_at ? moment.utc(row.created_at).local().fromNow() : moment.utc().local().fromNow(),
            sortable: true,
        },

    ];


    return (
        <React.Fragment>
            <Head title="ScratchCards"></Head>
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                                Scratch Card Winners
                            </BlockTitle>
                            <BlockDes className="text-soft">
                                <p>You have total {scratch_card_winners?.length} Scratch Card Winners.</p>
                            </BlockDes>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <div className="toggle-expand-content">
                                    <ul className="nk-block-tools g-3">
                                        <li className="nk-block-tools-opt">
                                            <Link to={'/scratch-cards'} color="primary" className="btn btn-primary" >
                                                <Icon name="arrow-left"></Icon>
                                                <span>Scratch Cards</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <ReactDataTable data={scratch_card_winners} columns={dataTableColumns} expandableRows pagination />

            </Content>
        </React.Fragment>
    );
}
export default ScratchCardWinner
